export const formatFloatToComma = value => {
    if (!value) return value

    let sanitizedValue = value.replace(/[^0-9,.]/g, '')

    sanitizedValue = sanitizedValue.replace('.', ',')

    if (sanitizedValue.includes(',')) {
        const [integerPart, decimalPart] = sanitizedValue.split(',')

        if (!decimalPart || /^0+$/.test(decimalPart)) {
            return integerPart
        }

        return `${integerPart},${decimalPart}`
    }

    return sanitizedValue
}
